const routes = [
    {
        path: "/quota/management",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "section_quota"
        }
    }
];

export default routes;
